import {
    fork,
    put,
    take,
    takeLatest,
    delay
} from "redux-saga/effects";
import {
    sagaActionTypes,
    updateAreasData,
    updateStagesData
} from "../actions/weevilTrakAction";
import {
    getWeeviltrakStages,
} from "@/util/http/WeevilTrak";
import { getAreas } from "@/util/http/WeevilTrak";
import { weevilTrakStore } from "@/util/localforageUtils";



function *fetchAreasData(){
    try{
        const res = yield getAreas();
        weevilTrakStore.setItem("weeviltrak_country", JSON.stringify(res?.data));
        yield put(updateAreasData(res.data));

    }
    catch(error){
        console.log("current countrycdoe have error",error);
    }
}

function *fetchWeevilTrakStages(){
    try{
        const res = yield getWeeviltrakStages();
        yield put(updateStagesData(res.data));

    }
    catch(error){
        console.log("current countrycdoe have error",error);
    }
}

function *rootSaga() {
    yield takeLatest(sagaActionTypes.SAGA_UPDATE_AREASDATA,fetchAreasData);
    yield takeLatest(sagaActionTypes.SAGA_UPDATE_WEEVILTRAKSTAGES,fetchWeevilTrakStages);
}

export default rootSaga;